import { mergeAttributes, Node } from '@tiptap/core';

export interface TableRowOptions {
    HTMLAttributes: Record<string, any>;
}

export const TableRow = Node.create<TableRowOptions>({
    name: 'tableRow',

    addOptions() {
        return {
            HTMLAttributes: {
                class: 'relative',
            },
        };
    },

    content: 'tableCell+',
    tableRole: 'wordRow',
    group: 'tableRow',

    addAttributes() {
        return {
            height: {
                default: null,
                parseHTML: element => {
                    return element.dataset.height || null;
                },
                renderHTML: attributes => {
                    if (attributes.height === null) {
                        return {};
                    }
                    return {
                        style: [attributes.height ? `height: ${attributes.height};` : ''].join(''),
                        ...(attributes.height ? { 'data-height': attributes.height } : {}),
                    };
                },
            },
            // heightRule: at_least, exactly, auto
            heightRule: {
                default: 'auto',
                parseHTML: element => {
                    return element.dataset.heightRule || 'auto';
                },
                renderHTML: attributes => {
                    return {
                        style: [
                            attributes.heightRule === 'at_least' ? `min-height: ${attributes.height};` : '',
                            attributes.heightRule === 'exactly' ? `max-height: ${attributes.height};` : '',
                            attributes.heightRule === 'auto' ? `height: auto;` : '',
                        ].join(''),
                        ...(attributes.heightRule ? { 'data-height-rule': attributes.heightRule } : {}),
                    };
                },
            },
        };
    },

    parseHTML() {
        return [{ tag: 'tr' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['tr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});
